import styled from "styled-components";

const CompanyName = styled.h3.attrs({ className: "text-uppercase" })`
  margin: 0 0 2px 0;
`;

export default CompanyName;
